import { useActivitiesContext } from '@user/features/Activity/context'
import { useCallback } from 'react'
import { closeContentActionCreator } from '@user/features/Activity/state'

export function useHandlers() {
  const [{ content }, dispatch] = useActivitiesContext()

  const handleClose = useCallback(
    (_, reason) => {
      if (reason === 'backdropClick' && content === 'list') {
        dispatch(closeContentActionCreator())
      }
    },
    [content, dispatch],
  )

  return {
    handleClose,
  }
}
